import React from 'react'

import UnidadComponentLoader from './UnidadComponentLoader'

const Mediacion = React.lazy(() => import('./mediacion/ActosPrevios'))
const Correduria = React.lazy(() => import('./correduria/ActosPrevios'))

export default function InfoPreliminar(params) {

    return (                     
        <UnidadComponentLoader 
            {...params}
            correduria={Correduria}
            mediacion={Mediacion}
        ></UnidadComponentLoader>       
    )

}